import { TextField, SxProps, Theme, InputAdornment } from '@mui/material';
import {
    searchInputStyles,
    StyledSearchIcon,
    StyledClearButton,
    StyledClearIcon
} from './styled';

export interface SearchInputWrapperProps {
    search: string;
    handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClear?: () => void;
    searchWidth?: string;
    sx?: SxProps<Theme>;
}

const SearchInputWrapper = ({
    search,
    handleSearch,
    onClear,
    sx
}: SearchInputWrapperProps) => {
    return (
        <TextField
            label="Search"
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        {search && onClear ? (
                            <StyledClearButton onClick={onClear} size="small">
                                <StyledClearIcon />
                            </StyledClearButton>
                        ) : (
                            <StyledSearchIcon />
                        )}
                    </InputAdornment>
                ),
                sx: searchInputStyles.searchInputSX
            }}
            InputLabelProps={{
                sx: searchInputStyles.searchLabelSX
            }}
            variant="standard"
            value={search}
            onChange={handleSearch}
            sx={sx}
        />
    );
};

export default SearchInputWrapper;
